import { createContext, useContext, FC, PropsWithChildren } from 'react';
import { UserRole } from 'types/user';
import { useAuth } from './auth';
import { ImpersonationState } from 'types/auth';

const ImpersonationContext = createContext<ImpersonationState>({} as ImpersonationState);

export const useImpersonation = () => useContext(ImpersonationContext);

export const ImpersonationProvider: FC<PropsWithChildren> = ({ children }) => {
  const { isImpersonated, impersonator, endImpersonation } = useAuth();

  const canActOnBehalf = isImpersonated && (
    impersonator?.role === UserRole.ROLE_SYSTEM_ADMIN ||
    !impersonator?.restrictActionsWhileImpersonating
  );

  const startImpersonation = async () => {
    window.location.href = '/';
  };

  return (
    <ImpersonationContext
      value={{
        isImpersonating: isImpersonated,
        impersonatorInfo: impersonator,
        canActOnBehalf,
        startImpersonation,
        endImpersonation,
      }}
    >
      {children}
    </ImpersonationContext>
  );
};
